import FundBulkUpdateModal from './FundBulkUpdateModal';

export default FundBulkUpdateModal;
